import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "row align-items-end mb-4" }
const _hoisted_2 = { class: "col-md-8 d-flex gap-2" }
const _hoisted_3 = { class: "col-md-4 text-md-end mt-3 mt-md-0" }
const _hoisted_4 = {
  key: 0,
  class: "text-muted fs-7"
}
const _hoisted_5 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KpiSection = _resolveComponent("KpiSection")!
  const _component_GrowthSection = _resolveComponent("GrowthSection")!
  const _component_EconomySection = _resolveComponent("EconomySection")!
  const _component_MonetizationSection = _resolveComponent("MonetizationSection")!
  const _component_EngagementSection = _resolveComponent("EngagementSection")!
  const _component_GeographySection = _resolveComponent("GeographySection")!
  const _component_RetentionSection = _resolveComponent("RetentionSection")!
  const _component_OpsSection = _resolveComponent("OpsSection")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("input", {
          type: "date",
          class: "form-control date-input",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fromIso) = $event))
        }, null, 512), [
          [_vModelText, _ctx.fromIso]
        ]),
        _withDirectives(_createElementVNode("input", {
          type: "date",
          class: "form-control date-input",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.toIso) = $event))
        }, null, 512), [
          [_vModelText, _ctx.toIso]
        ]),
        _createElementVNode("button", {
          class: "btn btn-primary",
          type: "button",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.reload && _ctx.reload(...args)))
        }, "Apply")
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.kpiSection.generatedAt.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
              _createTextVNode(" Updated " + _toDisplayString(_ctx.freshness) + " ", 1),
              (_ctx.kpiSection.stale.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, " · refreshing…"))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_KpiSection, {
      kpis: _ctx.kpiSection.data.value,
      loading: _ctx.kpiSection.loading.value,
      loaded: _ctx.kpiSection.loaded.value,
      error: _ctx.kpiSection.error.value
    }, null, 8, ["kpis", "loading", "loaded", "error"]),
    _createVNode(_component_GrowthSection, {
      growth: _ctx.growthSection.data.value,
      loading: _ctx.growthSection.loading.value,
      loaded: _ctx.growthSection.loaded.value,
      error: _ctx.growthSection.error.value
    }, null, 8, ["growth", "loading", "loaded", "error"]),
    _createVNode(_component_EconomySection, {
      economy: _ctx.economySection.data.value,
      loading: _ctx.economySection.loading.value,
      loaded: _ctx.economySection.loaded.value,
      error: _ctx.economySection.error.value
    }, null, 8, ["economy", "loading", "loaded", "error"]),
    _createVNode(_component_MonetizationSection, {
      monetization: _ctx.monetizationSection.data.value,
      loading: _ctx.monetizationSection.loading.value,
      loaded: _ctx.monetizationSection.loaded.value,
      error: _ctx.monetizationSection.error.value
    }, null, 8, ["monetization", "loading", "loaded", "error"]),
    _createVNode(_component_EngagementSection, {
      engagement: _ctx.engagementSection.data.value,
      loading: _ctx.engagementSection.loading.value,
      loaded: _ctx.engagementSection.loaded.value,
      error: _ctx.engagementSection.error.value
    }, null, 8, ["engagement", "loading", "loaded", "error"]),
    _createVNode(_component_GeographySection, {
      geography: _ctx.geographySection.data.value,
      loading: _ctx.geographySection.loading.value,
      loaded: _ctx.geographySection.loaded.value,
      error: _ctx.geographySection.error.value
    }, null, 8, ["geography", "loading", "loaded", "error"]),
    _createVNode(_component_RetentionSection, {
      retention: _ctx.retentionSection.data.value,
      loaded: _ctx.retentionSection.loaded.value,
      error: _ctx.retentionSection.error.value,
      onVisible: _ctx.loadRetention,
      onRetry: _ctx.loadRetention
    }, null, 8, ["retention", "loaded", "error", "onVisible", "onRetry"]),
    _createVNode(_component_OpsSection, {
      ops: _ctx.opsSection.data.value,
      loaded: _ctx.opsSection.loaded.value,
      error: _ctx.opsSection.error.value,
      onVisible: _ctx.loadOps,
      onRetry: _ctx.loadOps
    }, null, 8, ["ops", "loaded", "error", "onVisible", "onRetry"])
  ]))
}